module.exports = __webpack_public_path__ + "e38c0b60a0160d68c3bc71549056c98c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bloomberg_2021_chart.png
// module id = 1638
// module chunks = 0